import { Image as i } from "../../../components/Image/index.js";
import { css as r, styled as e } from "styled-components";
import { DarkThemeQuery as o, DarkNinjaThemeQuery as a } from "../../../styles/themes/index.js";
import { skeletonFadeAnimation as n } from "../../../styles/animation.js";
import { MediaQuery as s } from "../../../styles/variables.js";
const t = r`
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
  border-radius: 4px;
`, h = e.div`
  width: 100%;
  height: 100%;

  &.loading {
    width: 100%;
    object-fit: cover;
  }

  &[data-isinactive='true'] {
    filter: grayscale(100%) contrast(20%) brightness(1.5);
    ${o}, ${a} {
      filter: grayscale(100%) contrast(50%) brightness(0.6);
    }
  }
`, p = e.div`
  ${t}
  ${n}
`, f = e.div`
  ${t}

  @media ${s.SCREEN_MD_UP} {
    border-radius: 4px;
  }
  &[role='button'] {
    cursor: pointer;
  }
`, u = e(i)`
  width: 100%;
  height: 100%;
  img {
    aspect-ratio: 1/1;
    width: 100%;
  }
`;
export {
  h as DealImageContainer,
  p as DealImageSkeletonContainer,
  f as DealImageWrapper,
  u as ImageComponent
};
